import { Switch } from "native-base";

export default Switch;